var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"anchor",staticStyle:{"margin-bottom":"2rem"}}),_vm._l((_vm.wizardSteps),function(step){return _c('HubSpotStep',_vm._g({key:step,attrs:{"current-step-id":step,"steps":_vm.wizardSteps,"brand":_vm.brand},on:{"scroll-to-anchor-emit":_vm.scrollToAnchor}},_vm.$listeners))})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }